@import '~style-sheet-helpers/core.less';

.modal-body {
  padding: 16px 16px 48px;
}

.modal-body-text {
  font-size: 14px;
  line-height: 18px;
}

.terms-checkbox {
  padding-top: 16px;
}
